import { createApp } from "vue";
import "./style.less";
import App from "./App.vue";
import router from "./router";
import piniaStore from "./store";
import "./api/request";

const app = createApp(App);

app.use(router).use(piniaStore).mount("#app");
